(function () {
  const STORAGE_KEY = 'pethome_promo_popup';
  const SUBSCRIBED_KEY = 'pethome_promo_subscribed';

  function getPopup() {
    return document.querySelector('[data-promo-popup]');
  }

  function getHideDays(popup) {
    const days = parseInt(popup.dataset.hideDays, 10);
    return Number.isFinite(days) && days > 0 ? days : 14;
  }

  function getDelayMs(popup) {
    const seconds = parseInt(popup.dataset.delay, 10);
    return (Number.isFinite(seconds) && seconds > 0 ? seconds : 5) * 1000;
  }

  function readStorage() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writeStorage(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (e) {
      /* ignore */
    }
  }

  function hasSubscribed() {
    try {
      return localStorage.getItem(SUBSCRIBED_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markSubscribed() {
    try {
      localStorage.setItem(SUBSCRIBED_KEY, '1');
    } catch (e) {
      /* ignore */
    }
  }

  function shouldShow(popup) {
    if (!popup || document.documentElement.classList.contains('shopify-design-mode')) return false;
    if (hasSubscribed()) return false;

    const stored = readStorage();
    if (!stored || !stored.dismissedAt) return true;

    const hideMs = getHideDays(popup) * 24 * 60 * 60 * 1000;
    return Date.now() - stored.dismissedAt > hideMs;
  }

  function markDismissed(popup, permanent) {
    if (permanent) {
      markSubscribed();
      return;
    }
    writeStorage({ dismissedAt: Date.now() });
  }

  function openPopup(popup) {
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
      document.body.classList.add('promo-popup--open');
      const emailInput = popup.querySelector('#PromoPopupEmail');
      if (emailInput) emailInput.focus();
    });
  }

  function closePopup(popup, permanent) {
    if (!popup) return;
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('promo-popup--open');
    markDismissed(popup, permanent);
    window.setTimeout(function () {
      popup.hidden = true;
    }, 350);
  }

  function showSuccess(popup) {
    const formView = popup.querySelector('[data-promo-form-view]');
    const successView = popup.querySelector('[data-promo-success-view]');
    if (formView) formView.classList.add('is-hidden');
    if (successView) {
      successView.classList.remove('hide');
      successView.hidden = false;
    }
    markSubscribed();
  }

  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function getEmailError(email) {
    if (!email) return window.loginStrings?.errorEmailRequired || 'Introduce tu correo electrónico.';
    if (!validateEmail(email)) return window.loginStrings?.errorEmailInvalid || 'Correo electrónico no válido.';
    return '';
  }

  async function subscribe(email) {
    const body = new URLSearchParams({
      form_type: 'customer',
      utf8: '✓',
      'contact[email]': email,
      'contact[tags]': 'newsletter, bienvenida-10',
    });

    const response = await fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'text/html',
      },
      body: body.toString(),
      credentials: 'same-origin',
    });

    const html = await response.text();
    const alreadySubscribed =
      html.includes('newsletter_form.email_subscribed') ||
      html.includes('already subscribed') ||
      html.includes('ya estás suscrito');

    if (response.ok && !html.includes('input--error') && !html.includes('form-error')) {
      return { ok: true, alreadySubscribed };
    }

    if (alreadySubscribed) {
      return { ok: true, alreadySubscribed: true };
    }

    return { ok: false };
  }

  function scheduleShow(popup) {
    const delay = getDelayMs(popup);
    window.setTimeout(function () {
      if (shouldShow(popup)) openPopup(popup);
    }, delay);
  }

  function waitForCookieConsentThenShow(popup) {
    const cookieBanner = document.querySelector('[data-cookie-consent]');
    const consentStored = (function () {
      try {
        return localStorage.getItem('pethome_cookie_consent');
      } catch (e) {
        return null;
      }
    })();

    if (!cookieBanner || consentStored || !cookieBanner.classList.contains('is-visible')) {
      scheduleShow(popup);
      return;
    }

    document.addEventListener(
      'pethome:cookie-consent-closed',
      function onConsentClosed() {
        document.removeEventListener('pethome:cookie-consent-closed', onConsentClosed);
        scheduleShow(popup);
      },
      { once: true }
    );
  }

  function bindEvents(popup) {
    popup.querySelectorAll('[data-promo-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        closePopup(popup, false);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.classList.contains('is-visible')) {
        closePopup(popup, false);
      }
    });

    const form = popup.querySelector('#PromoPopupForm');
    const errorEl = popup.querySelector('#PromoPopupError');
    const submitBtn = popup.querySelector('[data-promo-submit]');
    const submitLabel = popup.querySelector('[data-promo-submit-label]');
    const submitLoading = popup.querySelector('[data-promo-submit-loading]');

    if (!form) return;

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      const emailInput = form.querySelector('input[type="email"]');
      const email = emailInput ? emailInput.value.trim() : '';
      const errorMessage = getEmailError(email);

      if (errorMessage) {
        if (errorEl) {
          errorEl.textContent = errorMessage;
          errorEl.classList.remove('hide');
        }
        emailInput?.focus();
        return;
      }

      if (errorEl) errorEl.classList.add('hide');
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel) submitLabel.classList.add('hide');
      if (submitLoading) submitLoading.classList.remove('hide');

      try {
        const result = await subscribe(email);
        if (result.ok) {
          showSuccess(popup);
        } else if (errorEl) {
          errorEl.textContent = 'No hemos podido guardar tu correo. Inténtalo de nuevo.';
          errorEl.classList.remove('hide');
        }
      } catch (e) {
        if (errorEl) {
          errorEl.textContent = 'Error de conexión. Inténtalo de nuevo.';
          errorEl.classList.remove('hide');
        }
      } finally {
        if (submitBtn) submitBtn.disabled = false;
        if (submitLabel) submitLabel.classList.remove('hide');
        if (submitLoading) submitLoading.classList.add('hide');
      }
    });
  }

  function init() {
    const popup = getPopup();
    if (!popup || !shouldShow(popup)) return;

    bindEvents(popup);
    waitForCookieConsentThenShow(popup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
